import  './polyfills';
import './vendor/pace/pace.min.js';

import { enableProdMode, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { HttpLoaderFactory } from './app/app.module';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { CNotificationModule } from '@shared/features/c-notification/c-notification.module';
import { notifierOptions } from '@shared/heplers/const-data';
import { NotifierModule } from 'angular-notifier';
import { rootRouterConfig } from './app/app.routes';
import { withInMemoryScrolling, provideRouter, withHashLocation } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { ShopModule } from './app/shop/shop.module';
import { FuseMainModule } from './app/main/main.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RecaptchaModule } from 'ng-recaptcha';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { SwRegistrationOptions, ServiceWorkerModule } from '@angular/service-worker';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DatePickerDataFormatterService, CustomDatepickerI18n } from '@shared/services/date-picker-data-formatter.service';
import { NgbDateParserFormatter, NgbDatepickerI18n, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationInterceptorService } from '@core/services/authentication-interceptor.service';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { initializer } from './app/utils/app-init';
import { GtmService } from '@shared/services/gtm.service';
import { ClipboardService } from '@core/services/clipoard.service';
import { CaptchaService } from '@shared/services/captcha.service';
import { GlobalHandlerService } from '@core/services/global-handler.service';
import { HttpClient, HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { SharedService } from '@core/services/shared.service';
import { AppService } from '@core/services/app.service';
import { CustomPageService } from '@shared/services/custom-pages.service';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(BrowserModule, RecaptchaModule, FuseMainModule, ShopModule, SharedModule, NgbModule, KeycloakAngularModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }), ToastrModule.forRoot({
            timeOut: 2000,
            progressBar: false,
            enableHtml: true,
        }), NotifierModule.withConfig(notifierOptions), CNotificationModule, ServiceWorkerModule.register('/ngsw-confing.json')),
        AppService,
        SharedService,
        { provide: 'googleTagManagerId', useValue: environment.gtmId },
        GlobalHandlerService,
        CaptchaService,
        ClipboardService,
        GtmService,
        CustomPageService,
        provideAppInitializer(() => {
        const initializerFn = (initializer)(inject(KeycloakService));
        return initializerFn();
      }),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptorService,
            multi: true,
        },
        {
            provide: NgbDateParserFormatter,
            useClass: DatePickerDataFormatterService,
        },
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        Location,
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        {
            provide: SwRegistrationOptions,
            useFactory: () => ({ enabled: false }),
        },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(rootRouterConfig, withInMemoryScrolling({ anchorScrolling: "enabled",
            scrollPositionRestoration: "enabled" })),
    ]
})
//  .then(() => {
//     const preloader = document.getElementById('loader-wrapper');
//     if (preloader) preloader.style.display = 'none';
//   })
  .catch(err => console.log(err));
